var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgControlCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 19 19"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F64ED",
  d: "m4.25 8.75 4 4 6.5-6.5"
})));
export { SvgControlCheck as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZwogICAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogICAgd2lkdGg9IjE5IgogICAgaGVpZ2h0PSIxOSIKICAgIHZpZXdCb3g9IjAgMCAxOSAxOSIKICAgIGZpbGw9Im5vbmUiCj4KICAgIDxwYXRoIGQ9Ik00LjI1IDguNzVMOC4yNSAxMi43NUwxNC43NSA2LjI1IiBzdHJva2U9IiMyRjY0RUQiIC8+Cjwvc3ZnPg==";